module.exports = __webpack_public_path__ + "img/print-icon.8feca451.svg";